import { KeyValue } from '../../types/KeyValue';

const boolean: KeyValue[] = [
    { key: true, value: 'Si' },
    { key: false, value: 'No' },
];

export default boolean;
